export default "__VITE_ASSET__CNDCB9WB__"